function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Parcel",
  d: "M17.777,25H3.224A3.311,3.311,0,0,1,0,21.615V7.825a.791.791,0,0,1,.09-.353A.067.067,0,0,0,.1,7.453.059.059,0,0,1,.1,7.434L3.285,1.682A3.211,3.211,0,0,1,6.073,0h8.854a3.211,3.211,0,0,1,2.788,1.682L20.9,7.434a.059.059,0,0,1,.005.019.067.067,0,0,0,.005.019.816.816,0,0,1,.09.355V21.615A3.311,3.311,0,0,1,17.777,25ZM1.488,8.608V21.615a1.783,1.783,0,0,0,1.736,1.823H17.777a1.783,1.783,0,0,0,1.736-1.823V8.608Zm9.757-7.046V7.046h7.719L16.428,2.469a1.728,1.728,0,0,0-1.5-.906Zm-5.171,0a1.728,1.728,0,0,0-1.5.906L2.037,7.046H9.756V1.562ZM9.585,19.448a.708.708,0,0,1-.511-.218L6.047,16.141a.749.749,0,0,1,0-1.047.714.714,0,0,1,1.025,0l2.514,2.563,5.428-5.536a.717.717,0,0,1,1.026,0,.752.752,0,0,1,0,1.048L10.1,19.23A.714.714,0,0,1,9.585,19.448Z",
  fill: "#ff7643"
});

var SvgIconParcel = function SvgIconParcel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconParcel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-parcel.31d0b62d.svg";
export { ForwardRef as ReactComponent };